import { css } from 'styled-components';

import { requireImage } from '@nubank/www-latam-commons/utils/requireImage';

export function handleNotSupportedType(args, type = 'webp') {
  return `
    .no-${type} & {
      ${args}
    }
  `;
}

function addTypeBackgroundImage(imagePath, type = 'webp') {
  return css`
    background-image: url(${requireImage(imagePath, type)});
    ${handleNotSupportedType(`background-image: url(${requireImage(imagePath)})`)}
  `;
}

export default addTypeBackgroundImage;
